<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('monthly.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'monthlies' }">{{ $t('monthly.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-form @submit="submitParam">
          <b-input-group size="lg">
            <b-form-select
              v-model="year"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="">{{ $t('monthly.list.search-bar.year-selector.hint') }}</b-form-select-option>
              <b-form-select-option :value="n" v-for="n in years">{{ $t('monthly.list.search-bar.year-selector.option.label', { year: n }) }}</b-form-select-option>
            </b-form-select>
            <b-form-select
              v-model="month"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="">{{ $t('monthly.list.search-bar.month-selector.hint') }}</b-form-select-option>
              <b-form-select-option :value="n" v-for="n in 12">{{ $t('monthly.list.search-bar.month-selector.option.label', { month: n }) }}</b-form-select-option>
            </b-form-select>
            <b-input-group-append>
              <b-button type="submit" variant="primary">{{ $t('monthly.list.search-bar.search-button.label') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col">
          <b-list-group>
            <b-list-group-item
              class="d-flex w-100 justify-content-between align-items-center"
              v-for="monthly in monthlies"
            >
              <h5>
                <span class="d-inline-block">{{ monthly.publication_date }}</span>
                &nbsp;<span class="d-none d-sm-inline-block">/</span>&nbsp;
                <span class="d-inline-block">{{ $t('issue', { issue: monthly.issue }) }}</span>
              </h5>
              <b-button
                squared
                variant="outline-primary"
                target="_blank"
                :href="monthly.attachments.length > 0 ? monthly.attachments[0].url : ''"
              >{{ $t('monthly.list.button.read.label') }}</b-button>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="per_page"
            @change="pageChange"
            align="center"
            size="lg"
          ></b-pagination>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import { stringify } from 'query-params-helpers'
import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

import MonthlyApiService from '@/services/budaedu-api-services/monthly-api-service.js'

Vue.use(axios)
Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(IconsPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ListGroupPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)
Vue.use(VueAxios)

Vue.use(MonthlyApiService)

export default {
  i18n,
  name: 'monthlies',
  data() {
    return {
      is_loading: false,
      year: '',
      month: '',
      years: [],
      per_page: 12,
      page: 1,
      total: 0,
      monthlies: []
    }
  },
  methods: {
    submitParam(event) {
      event.preventDefault()
      this.page = 1
      this.setMonthliesAndPaging()
    },
    pageChange(page) {
      this.page = page
      this.setMonthliesAndPaging()
    },
    async setYears() {
      this.years = await this.$monthlyApiService.getListOfPublicationYear()
    },
    async setMonthliesAndPaging() {
      this.is_loading = true
      this.monthlies = []
      try {
        let filter = {}
        if (this.year !== '') {
          filter.of_year = this.year
        }
        if (this.month !== '') {
          filter.of_month = this.month
        }

        let params = stringify({
          include: 'attachments',
          filter: filter,
          per_page: this.per_page,
          page: this.page,
          order: 'publication_date,desc'
        }).substr(1)

        const items = await this.$monthlyApiService.query(params)
        this.monthlies = items.data
        this.total = items.meta.total
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setMonthliesAndPaging()
    await this.setYears()
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('monthly.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>